<template>
  <div id="Nip__search__form">
    <a-row>
      <a-col :span="18" :offset="3" class="col_text">
        <h3>{{ $t("NipSearchForm_header_text_one") }}</h3>
        <h4>{{ $t("NipSearchForm_header_text_two") }}</h4>
      </a-col>
      <a-col :span="12" :offset="6">
        <a-input-search
          size="large"
          :defaultValue="defaultNip"
          :placeholder="$t('Input search NIP')"
          @search="onSearch"
          enterButton
        />
      </a-col>
    </a-row>
    <br />
    <br />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  props: ["defaultNip"],
  data() {
    return {};
  },
  mounted() {
    this.resizeWindow();
  },
  updated() {
    this.resizeWindow();
  },
  computed: mapGetters([
    "InfoOnNIP",
    "FormData",
    "saveCompanyTypeNip",
    "settingsNip",
  ]),
  methods: {
    async onSearch(value) {
      let check = this.cheakSettings();
      if (this.saveCompanyTypeNip.Fields && check.length) {
        this.$error({
          title: this.$t("You cannot save to company fields"),
          content:
            this.$t("You need to fill in the fields of the table") +
            " - " +
            check.toString(),
        });
      } else {
        let nums = value.match(/\d{1}/g);
        if (nums && nums.length == 10) {
          let inputNIP = nums.reduce((a, b) => a + b);

          // this.changeSpinning();
          await this.fetchSearchCompanyByNIP(inputNIP);

          if (this.InfoOnNIP.error) {
            // this.changeSpinning();
            this.$notification.error({
              message: this.InfoOnNIP.error,
              description: inputNIP || "",
              placement: "topRight",
            });
          } else {
            await this.BXsearchCompanyByNIP(this.InfoOnNIP.NIP);
            this.CreateFormData(this.InfoOnNIP);

            this.NextStep();
          }
        } else {
          this.$notification.error({
            message: this.$t("Incorrect NIP entered"),
            description: value || "",
            placement: "topRight",
          });
        }
      }
    },
    cheakSettings() {
      let flag = [];
      for (let i in this.settingsNip) {
        if (!this.settingsNip[i].name || !this.settingsNip[i].id)
          flag.push(this.$t(i));
      }
      return flag;
    },
    ...mapActions([
      "NextStep",
      "fetchSearchCompanyByNIP",
      "BXsearchCompanyByNIP",
      "CreateFormData",
      "resizeWindow",
      "changeSpinning",
    ]),
  },
};
</script>

<style scoped>
.col_text {
  text-align: center;
  margin-bottom: 50px;
}
</style>
